import * as React from 'react';
export const historySvg = React.forwardRef(function historySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.857 0c3.4 0 6.14 2.686 6.14 6s-2.75 6-6.14 6C3.149 12 .851 10.285.037 7.906-.121 7.444.253 7 .742 7c.367 0 .68.256.812.599.66 1.695 2.337 2.9 4.303 2.901 2.543 0 4.604-2.014 4.604-4.5 0-2.487-2.054-4.5-4.604-4.5-1.398 0-2.65.61-3.495 1.571l.897.196a.751.751 0 0 1-.318 1.465L.798 4.267a.95.95 0 0 1-.748-.928V.799a.75.75 0 0 1 1.5 0v.93l.038-.039A6.192 6.192 0 0 1 5.858 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.75 3a.75.75 0 0 1 .75.75v2.825l1.511.906A.75.75 0 0 1 7.24 8.77L5.364 7.644A.75.75 0 0 1 5 7V3.75A.75.75 0 0 1 5.75 3Z',
    }),
  );
});
historySvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var history = {
  category: 'icon',
  colorable: true,
  name: 'history',
  svg: historySvg,
};
